import {
  ExchangeRateSnapshotSchema,
  type ExchangeRateSnapshot,
} from "../../../../shared/contracts/exchange-rates";

export type ExchangeRateClientErrorCode = "http" | "invalid_response" | "network" | "aborted";

const MESSAGE_BY_CODE: Record<ExchangeRateClientErrorCode, string> = {
  http: "官方汇率暂时不可用",
  invalid_response: "官方汇率响应无效",
  network: "官方汇率网络暂时不可用",
  aborted: "汇率请求已取消",
};

export class ExchangeRateClientError extends Error {
  public readonly code: ExchangeRateClientErrorCode;

  public constructor(code: ExchangeRateClientErrorCode) {
    super(MESSAGE_BY_CODE[code]);
    this.name = "ExchangeRateClientError";
    this.code = code;
  }
}

export async function getExchangeRates(signal?: AbortSignal, asOfDate?: string): Promise<ExchangeRateSnapshot> {
  let response: Response;
  try {
    const path = asOfDate ? `/api/exchange-rates?asOf=${encodeURIComponent(asOfDate)}` : "/api/exchange-rates";
    response = await fetch(path, signal ? { signal } : {});
  } catch (error) {
    if (signal?.aborted || (error instanceof DOMException && error.name === "AbortError")) {
      throw new ExchangeRateClientError("aborted");
    }
    throw new ExchangeRateClientError("network");
  }
  if (!response.ok) throw new ExchangeRateClientError("http");

  let payload: unknown;
  try {
    payload = await response.json();
  } catch {
    throw new ExchangeRateClientError("invalid_response");
  }
  const parsed = ExchangeRateSnapshotSchema.safeParse(payload);
  if (!parsed.success) throw new ExchangeRateClientError("invalid_response");
  return parsed.data;
}
